import { defineNuxtPlugin } from '#app'
import { ARShadowScroll } from '@/directives/ARShadowScroll'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('ar-shadow-scroll', ARShadowScroll)
})
